export default [
  {
    input: 'Dhaval.currentLocation',
    return: '"Bangalore, India"',
  },
  {
    input: 'Dhaval.resume',
    return:
      '"<a rel="noopener" href="/Dhaval_singh.pdf" target="_blank">DhavalSingh.pdf</a>"',
  },
  {
    input: 'Dhaval.Website',
    return:
      '"<a rel="noopener" href="https://dhavalsingh.github.io/" target="_blank">Personal Website</a>"',
  },
  {
    input: 'Dhaval.education',
    return:
      '"M.Sc. Physics and B.E. Electronics And Instrumentation from Bits Pilani K.K Birla Goa campus"',
  },
  {
    input: 'Dhaval.skills',
    return:
      '["Java", "JavaScript", "Python", ""ReactJS, "C++", "HTML", "TypeScript", "git"]',
  },
  {
    input: 'Dhaval.interests',
    return: '["Football", "Esports", "Cooking", "Movies"]',
  },
];



// WEBPACK FOOTER //
// ./src/content/about-me.js